import { render, staticRenderFns } from "./CourseMediaView.vue?vue&type=template&id=03341a4e"
import script from "./CourseMediaView.vue?vue&type=script&lang=js"
export * from "./CourseMediaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports